/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { FormControl } from "@mui/material";
import PropTypes from "prop-types";

const FormControlComp = ({ title, value }) => {
  return (
    <FormControl
        disabled
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "63px",
          minWidth: "48%",
          gap: "4px"
        }}
      >
        <label className="publisherLabel">
          <span className="publisherTitle">{title}</span>
          <span className="asterisk">*</span>
        </label>

        <input className="publisherInfoText" id={value} value={value} type="text" disabled />
      </FormControl>
  );
};

FormControlComp.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
};

export default FormControlComp;
